/// \file preferencesUseStates.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import React, {useState} from 'react';
import { preferencesUseStateInterface } from './preferencesUseStateInterface';
import { SetFilter } from '../../../components/filter/setFilter';
const preferencesUseStates = ():preferencesUseStateInterface => {
const updateFilter = () => {
  console.log("filter change");
};
//dateNumberFormat type
const dateNumberFormatTypeDropdown = [
  "ENGLISH",
  "FRENCH",
  "SPANISH",
  "DUTCH",
  ];
  
  const [dateNumberFormat, setdateNumberFormat] = useState <null|string[]>(dateNumberFormatTypeDropdown);
  const dateNumberFormatFilterChange = (event:{filter:{field:string,operator:string,value:string}}) => {
          const filter=event.filter;
          const currentArray=dateNumberFormat;
          const totalArray=dateNumberFormatTypeDropdown;
          const setFilterReturn = SetFilter({filter,currentArray,totalArray});
          setdateNumberFormat(setFilterReturn.filteredArray);
          if(setFilterReturn.updateFilter){
                  updateFilter();
          }
  };
  
  const [dateNumberFormatValue, setdateNumberFormatValue] = useState <null|string>(null);
  const dateNumberFormatChange = (e:{value:null|string}) => {
          setdateNumberFormatValue(e.value);
          updateFilter();
  };

//timeZone type
const timeZoneTypeDropdown = [
  "Eastern Time",
  "Alaska",
  "Central Time",
  "Pacific Time",
  ];
  
  const [timeZone, settimeZone] = useState <null|string[]>(timeZoneTypeDropdown);
  const timeZoneFilterChange = (event:{filter:{field:string,operator:string,value:string}}) => {
          const filter=event.filter;
          const currentArray=timeZone;
          const totalArray=timeZoneTypeDropdown;
          const setFilterReturn = SetFilter({filter,currentArray,totalArray});
          settimeZone(setFilterReturn.filteredArray);
          if(setFilterReturn.updateFilter){
                  updateFilter();
          }
  };
  
  const [timeZoneValue, settimeZoneValue] = useState <null|string>(null);
  const timeZoneChange = (e:{value:null|string}) => {
          settimeZoneValue(e.value);
          updateFilter();
  };

//firstDay type
const firstDayTypeDropdown = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  ];
  
  const [firstDay, setfirstDay] = useState <null|string[]>(firstDayTypeDropdown);
  const firstDayFilterChange = (event:{filter:{field:string,operator:string,value:string}}) => {
          const filter=event.filter;
          const currentArray=firstDay;
          const totalArray=firstDayTypeDropdown;
          const setFilterReturn = SetFilter({filter,currentArray,totalArray});
          setfirstDay(setFilterReturn.filteredArray);
          if(setFilterReturn.updateFilter){
                  updateFilter();
          }
  };
  
  const [firstDayValue, setfirstDayValue] = useState <null|string>(null);
  const firstDayChange = (e:{value:null|string}) => {
          setfirstDayValue(e.value);
          updateFilter();
  };

//units type
const unitsTypeDropdown = [
  "US (Miles, Gallons, etc.)",
  "METRIC (Meters, Liters, etc.)"
  ];
  
  const [units, setunits] = useState <null|string[]>(unitsTypeDropdown);
  const unitsFilterChange = (event:{filter:{field:string,operator:string,value:string}}) => {
          const filter=event.filter;
          const currentArray=units;
          const totalArray=unitsTypeDropdown;
          const setFilterReturn = SetFilter({filter,currentArray,totalArray});
          setunits(setFilterReturn.filteredArray);
          if(setFilterReturn.updateFilter){
                  updateFilter();
          }
  };
  
  const [unitsValue, setunitsValue] = useState <null|string>(null);
  const unitsChange = (e:{value:null|string}) => {
          setunitsValue(e.value);
          updateFilter();
  };

//decimals type
const decimalsTypeDropdown = [
  "NONE (0)",
  "ONE (0.0)",
  "TWO (0.00)",
  "THREE (0.000)",
  ];
  
  const [decimals, setdecimals] = useState <null|string[]>(decimalsTypeDropdown);
  const decimalsFilterChange = (event:{filter:{field:string,operator:string,value:string}}) => {
          const filter=event.filter;
          const currentArray=decimals;
          const totalArray=decimalsTypeDropdown;
          const setFilterReturn = SetFilter({filter,currentArray,totalArray});
          setdecimals(setFilterReturn.filteredArray);
          if(setFilterReturn.updateFilter){
                  updateFilter();
          }
  };
  
  const [decimalsValue, setdecimalsValue] = useState <null|string>(null);
  const decimalsChange = (e:{value:null|string}) => {
          setdecimalsValue(e.value);
          updateFilter();
  };

//records type
const recordsTypeDropdown = [
  "5",
  "10",
  "20",
  "25",
  "50",
  "100",
  ];
  
  const [records, setrecords] = useState <null|string[]>(recordsTypeDropdown);
  const recordsFilterChange = (event:{filter:{field:string,operator:string,value:string}}) => {
          const filter=event.filter;
          const currentArray=records;
          const totalArray=recordsTypeDropdown;
          const setFilterReturn = SetFilter({filter,currentArray,totalArray});
          setrecords(setFilterReturn.filteredArray);
          if(setFilterReturn.updateFilter){
                  updateFilter();
          }
  };
  
  const [recordsValue, setrecordsValue] = useState <null|string>(null);
  const recordsChange = (e:{value:null|string}) => {
          setrecordsValue(e.value);
          updateFilter();
  };

//mapType type
const mapTypeTypeDropdown = [
  "ROAD",
  "SATELLITE",
  "TERRAIN",
  "HYBRID",
  ];
  
  const [mapType, setmapType] = useState <null|string[]>(mapTypeTypeDropdown);
  const mapTypeFilterChange = (event:{filter:{field:string,operator:string,value:string}}) => {
          const filter=event.filter;
          const currentArray=mapType;
          const totalArray=mapTypeTypeDropdown;
          const setFilterReturn = SetFilter({filter,currentArray,totalArray});
          setmapType(setFilterReturn.filteredArray);
          if(setFilterReturn.updateFilter){
                  updateFilter();
          }
  };
  
  const [mapTypeValue, setmapTypeValue] = useState <null|string>(null);
  const mapTypeChange = (e:{value:null|string}) => {
          setmapTypeValue(e.value);
          updateFilter();
  };

//mapApp type
const mapAppTypeDropdown = [
  "Apple",
  "Android"
  ];
  
  const [mapApp, setmapApp] = useState <null|string[]>(mapAppTypeDropdown);
  const mapAppFilterChange = (event:{filter:{field:string,operator:string,value:string}}) => {
          const filter=event.filter;
          const currentArray=mapApp;
          const totalArray=mapAppTypeDropdown;
          const setFilterReturn = SetFilter({filter,currentArray,totalArray});
          setmapApp(setFilterReturn.filteredArray);
          if(setFilterReturn.updateFilter){
                  updateFilter();
          }
  };
  
  const [mapAppValue, setmapAppValue] = useState <null|string>(null);
  const mapAppChange = (e:{value:null|string}) => {
          setmapAppValue(e.value);
          updateFilter();
  };

//deliveryDay type
const deliveryDayTypeDropdown = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  ];
  
  const [deliveryDay, setdeliveryDay] = useState <null|string[]>(deliveryDayTypeDropdown);
  const deliveryDayFilterChange = (event:{filter:{field:string,operator:string,value:string}}) => {
          const filter=event.filter;
          const currentArray=deliveryDay;
          const totalArray=deliveryDayTypeDropdown;
          const setFilterReturn = SetFilter({filter,currentArray,totalArray});
          setdeliveryDay(setFilterReturn.filteredArray);
          if(setFilterReturn.updateFilter){
                  updateFilter();
          }
  };
  
  const [deliveryDayValue, setdeliveryDayValue] = useState <null|string>(null);
  const deliveryDayChange = (e:{value:null|string}) => {
          setdeliveryDayValue(e.value);
          updateFilter();
  };
  

//deliveryTime type
const deliveryTimeTypeDropdown = [
  "12:00 AM",
  "01:00 AM",
  "02:00 AM",
  "03:00 AM",
  "04:00 AM",
  "05:00 AM",
  "06:00 AM",
  "07:00 AM",
  "08:00 AM",
  "09:00 AM",
  "10:00 AM",
  "11:00 AM",
  "12:00 PM",
  ];
  
  const [deliveryTime, setdeliveryTime] = useState <null|string[]>(deliveryTimeTypeDropdown);        
  const deliveryTimeFilterChange = (event:{filter:{field:string,operator:string,value:string}}) => {
          const filter=event.filter;
          const currentArray=deliveryTime;
          const totalArray=deliveryTimeTypeDropdown;
          const setFilterReturn = SetFilter({filter,currentArray,totalArray});
          setdeliveryTime(setFilterReturn.filteredArray);
          if(setFilterReturn.updateFilter){
                  updateFilter();
          }
  };

  const [deliveryTimeValue, setdeliveryTimeValue] = useState <null|string>(null);
  const deliveryTimeChange = (e:{value:null|string}) => {
          setdeliveryTimeValue(e.value);
          updateFilter();
  };

//csv type
const csvTypeDropdown = [
  "YES",
  "NO"
  ];
  
  const [csv, setcsv] = useState <null|string[]>(csvTypeDropdown);
  const csvFilterChange = (event:{filter:{field:string,operator:string,value:string}}) => {
          const filter=event.filter;
          const currentArray=csv;
          const totalArray=csvTypeDropdown;
          const setFilterReturn = SetFilter({filter,currentArray,totalArray});
          setcsv(setFilterReturn.filteredArray);
          if(setFilterReturn.updateFilter){
                  updateFilter();
          }
  };
  
  const [csvValue, setcsvValue] = useState <null|string>(null);
  const csvChange = (e:{value:null|string}) => {
          setcsvValue(e.value);
          updateFilter();
  };

const [current, setCurrent] = useState<{
  faults:string,
  timeZone:null|string,
  deliveryTime:null|string,
  csv:null|string,
  deliveryDay:null|string,
  mapApp:null|string,
  mapType:null|string,
  records:null|string,
  decimals:null|string,
  units:null|string,
  firstDay:null|string,
  dateNumberFormat:null|string,
}>({
  faults:"",
  timeZone:timeZoneValue,
  deliveryTime:deliveryTimeValue,
  csv:csvValue,
  deliveryDay:deliveryDayValue,
  mapApp:mapAppValue,
  mapType:mapTypeValue,
  records:recordsValue,
  decimals:decimalsValue,
  units:unitsValue,
  firstDay:firstDayValue,
  dateNumberFormat:dateNumberFormatValue
});

  const pairs=[
    {name:"faults",title:"* FAULT ACTIVE (HRS)",style:"input","values":"faults"},
    {name:"timeZone",title:"* PREFERRED TIME ZONE",style:"single-select","values":{data:timeZone,placeholder:"ANY",startValue:timeZoneValue,onChange:timeZoneChange,onFilterChange:timeZoneFilterChange}},
    {name:"deliveryTime",title:"* PREFERRED DIGEST EMAIL DELIVERY TIME",style:"single-select","values":{data:deliveryTime,placeholder:"ANY",startValue:deliveryTimeValue,onChange:deliveryTimeChange,onFilterChange:deliveryTimeFilterChange}},
    {name:"csv",title:"* INCLUDE *.CSV FILE WITH DIGEST EMAILS",style:"single-select","values":{data:csv,placeholder:"ANY",startValue:csvValue,onChange:csvChange,onFilterChange:csvFilterChange}},
    {name:"deliveryDay",title:"* PREFERRED WEEKLY DIGEST EMAIL DELIVERY DAY",style:"single-select","values":{data:deliveryDay,placeholder:"ANY",startValue:deliveryDayValue,onChange:deliveryDayChange,onFilterChange:deliveryDayFilterChange}},
    {name:"mapApp",title:"MAPPING APP",style:"single-select","values":{data:mapApp,placeholder:"ANY",startValue:mapAppValue,onChange:mapAppChange,onFilterChange:mapAppFilterChange}},
    {name:"mapType",title:"MAPBOX TYPE",style:"single-select","values":{data:mapType,placeholder:"ANY",startValue:mapTypeValue,onChange:mapTypeChange,onFilterChange:mapTypeFilterChange}},
    {name:"records",title:"* PREFERRED RECORDS PER PAGE",style:"single-select","values":{data:records,placeholder:"ANY",startValue:recordsValue,onChange:recordsChange,onFilterChange:recordsFilterChange}},
    {name:"decimals",title:"PREFERRED DECIMAL PLACES",style:"single-select","values":{data:decimals,placeholder:"ANY",startValue:decimalsValue,onChange:decimalsChange,onFilterChange:decimalsFilterChange}},
    {name:"units",title:"* PREFERRED UNIT SYSTEM",style:"single-select","values":{data:units,placeholder:"ANY",startValue:unitsValue,onChange:unitsChange,onFilterChange:unitsFilterChange}},
    {name:"firstDay",title:"FIRST DAY OF WEEK",style:"single-select","values":{data:firstDay,placeholder:"ANY",startValue:firstDayValue,onChange:firstDayChange,onFilterChange:firstDayFilterChange}},
    {name:"dateNumberFormat",title:"* PREFERRED DATE/NUMBER LOCALE",style:"single-select","values":{data:dateNumberFormat,placeholder:"ANY",startValue:dateNumberFormatValue,onChange:dateNumberFormatChange,onFilterChange:dateNumberFormatFilterChange}},
  ];

  const setCurrentPreferences = setCurrent;
  const pairsPreferences = pairs;
  return {     
    timeZoneValue,     
    deliveryTimeValue, 
    csvValue,
    deliveryDayValue,
    mapAppValue,
    mapTypeValue,
    recordsValue,
    decimalsValue,
    unitsValue,
    firstDayValue,
    dateNumberFormatValue,
    setCurrentPreferences,
    pairsPreferences,
  };
};

export default preferencesUseStates;